<template>
    <!-- START: section-tariffswiper -->
    <section class="section section-tariffswiper has-filter bg-white" id="tarifliste">
        <div class="tariff-filter pt-4 pb-0 mb-0">
            <div class="container" v-if="visibleTarife.length">
                <div class="tf-intro mb-0" v-if="tarifTyp === 'gas'">
                    <h2 class="mb-0" v-if="settings.headlineGastarife && settings.headlineGastarife.length > 0" v-html="settings.headlineGastarife"></h2>
                    <h2 class="mb-0" v-else>Ihre passenden Erdgastarife</h2>
                </div>
                <div class="tf-intro mb-0" v-else-if="tarifTyp === 'strom'">
                    <h2 class="mb-0" v-if="settings.headlineStromtarife && settings.headlineStromtarife.length > 0" v-html="settings.headlineStromtarife"></h2>
                    <h2 class="mb-0" v-else>Ihre passenden Stromtarife</h2>
                </div>
                <div class="tf-filter mt-3"
                     v-if="settings.produktfilteranzeigen == '1' && settings.produktfilter.length > 0">
                    <div class="tf-label">Tarife filtern:</div>

                    <div class="custom-control custom-checkbox" v-for="(pfilter, pfindex) in settings.produktfilter"
                         :key="pfindex">
                        <input type="checkbox" class="custom-control-input" :id="'pf' + pfilter.uid"
                               :value="pfilter.uid"
                               v-model="cbProduktfilter"
                               @change="$emit('changeProduktfilter', cbProduktfilter)"
                               :tabindex="0"
                        >
                        <label class="custom-control-label" :for="'pf' + pfilter.uid">{{ pfilter.name_extern }}</label>
                    </div>

                </div>
            </div>
            <div class="container" v-else>
                <div class="tf-intro loader" v-if="loading">
                    <medium-loader/>
                </div>
                <div class="container" v-html="keineTarifeHtml" style="display: flex; flex-direction: column; align-items: center;">
                    <!--                    Leider konnten für Ihre Angaben aktuell keine Preise ermittelt werden.-->
                    <!--                    <a target="_blank" :href="'https://gutundgruen.de/preisanzeige/' + this.tarifTyp + '/' + this.plz + '/' + this.verbrauch + '/?stadt=' + encodedStadt + '&strasse=' + encodedStrasse + '&hausnummer=' +this.hnr+this.hnrzusatz">Link</a>-->
                </div>
            </div>
        </div>
        <div class="container">
            <!-- Swiper -->
            <div ref="swiper"
                 class="tariffswiper"
                 :class="{'swiper-container swiper-container-horizontal': swiperOptions.slidesPerView !== 0, 'swiper-container-vertical': swiperOptions.slidesPerView === 0}"
            >
                <div class="swiper-wrapper">

                    <tarif-liste-item v-for="(tarif, index) in visibleTarife"
                                      :key="index"
                                      :tarif="tarif"
                                      :settings="settings"
                                      :preisoptionen="preisoptionen"
                                      :toggleDetails="toggleDetails"
                                      :grundversorger="grundversorger"
                                      :plz="plz"
                                      @input:preisOptionen="value => preisoptionen = value"
                                      @checkout="(tarif, poptions, jvl) => $emit('checkout', tarif, poptions, jvl)"
                                      v-on:togglePriceDetails="handlePriceDetailsToggle"
                                      v-on:applyMatchHeightToTariffItems="handleMatchHeightForTariffItems"
                    />

                </div>
                <!-- Add Pagination -->
                <div class="swiper-pagination" v-show="swiperOptions.slidesPerView > 0 && visibleTarife.length > 1"></div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
                <div class="explanatory" v-if="gvsSwboPreis > 0 && gvsSwboPreis == 'test'"><sup>1</sup>  xxxxxxxxxxxx Die genannte Ersparnis im ersten Jahr bezieht sich auf den örtlichen Grundversorgungstarif des Grundversorgers DEW21 (Dortmunder Energie- und Wasserversorgungs GmbH) und beinhaltet den ausgelobten Neukundenbonus in Höhe von 50,00 €. Der Grundversorgungstarif Unser Strom.standard beinhaltet einen Arbeitspreis von 43,04 Cent und einen jährlichen Grundpreis von 166,79 €. Neben dem Grundversorgungstarif bietet DEW21 (Dortmunder Energie- und Wasserversorgungs GmbH) noch weitere günstigere Tarife - evtl. auch mit einer Preisgarantie und einer Bonuszahlung - an. Stand der Daten aus der ene't-Datenbank 01.01.20123. Alle Preise inkl. aller Umlagen und Abgaben. Der Grundversorgungstarif hat keine Laufzeit und eine gesetzliche Kündigungsfrist von zwei Wochen.</div>
            </div>

            <PriceHistory
                v-if="settings.layoutergebnisseite === 'vertical' && visibleTarife.length === 1 && visibleTarife[0].tarif_typ === 2"
                :plz="plz"
                :color="visibleTarife[0].farbigkeit === 'gruen' ? 'green' : ''"
                :tarif-id="visibleTarife[0].flex_id"
                :regular-price="typeof settings.flexRegularPrice === 'string' ? parseFloat(settings.flexRegularPrice.replace(',', '.')) : settings.flexRegularPrice"
                :hide-regular="!!settings.flexHideRegular"
                :hide-average="!!settings.flexHideAverage"
                :hide-switch-day="!!settings.flexHideSwitchDay"
                :hide-switch-savings="!!settings.flexHideSwitchSavings"
                :text-before="settings.flexTextBefore"
                :text-after="settings.flexTextAfter"
            />

        </div>
    </section>
    <!-- END: section-tariffswiper -->
</template>

<script>
import Swiper, { Pagination, Navigation } from 'swiper';
import {debounce} from "lodash-es";

import MediumLoader from "@/components/Loader/MediumLoader";
import TarifListeItem from "@/components/TarifListeItem";
import $ from 'jQuery';
import PriceHistory from "@/components/PriceHistory.vue";

import MatchHeight from '@tannerhodges/match-height';

export default {
    name: 'TarifListe',
    components: {
        PriceHistory,
        MediumLoader, TarifListeItem
    },
    props: {
        settings: {
            type: Object,
            default: () => {
            },
        },
        tarife: {
            type: Array,
            default: () => [],
        },
        tarifTyp: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        strasse: {
            type: String,
            default: ''
        },
        hnr: {
            type: String,
            default: ''
        },
        hnrzusatz: {
            type: String,
            default: ''
        },
        stadt: {
            type: String,
            default: ''
        },
        plz: {
            type: String,
            default: ''
        },
        verbrauch: {
            type: String,
            default: ''
        },
        grundversorger: {
            type: Object,
            default: () => {},

        },
        keineTarifeHtml: {
            type: String,
            default: ''
        }
    },
    mounted() {
        this.updateSwiper();
    },
    created() {
        this.onResize = debounce(this.onResize, 200);
        window.addEventListener('resize', this.onResize);
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize);
        if (this.swiper) this.swiper.destroy();
    },
    data() {
        return {
            cbProduktfilter: [],
            preisoptionen: {},
            swiper: null,
            windowWidth: window.innerWidth,
            toggleDetails: false,
            gvsSwboPreis: 0 // @todo muss angeliefert werden
        }
    },
    computed: {
        visibleTarife() {
          return this.tarife.filter(tarif => !tarif.invisible);
        },
        swiperOptions() {
            let slidesPerView = 1;
            let spaceBetween = 20;
            if (this.windowWidth >= 0) {
                slidesPerView = 1;
                spaceBetween = 20;
            }
            if (this.windowWidth >= 768) {
                slidesPerView = 1;
                spaceBetween = 30;
            }
            if (this.windowWidth >= 992) {
                slidesPerView = 2;
                spaceBetween = 30;
            }
            if (this.windowWidth >= 1200) {
                slidesPerView = this.settings.layoutergebnisseite === 'horizontal' ? 3 : 0;
                spaceBetween = 60;
            }
            if (this.windowWidth >= 1680) {
                slidesPerView = this.settings.layoutergebnisseite === 'horizontal' ? 3 : 0;
                spaceBetween = 60;
            }
            if (this.windowWidth >= 2400) {
                slidesPerView = this.settings.layoutergebnisseite === 'horizontal' ? 4 : 0;
                spaceBetween = 60;
            }


            return {
                slidesPerView,
                spaceBetween
            }
        },
    },
    methods: {
        handlePriceDetailsToggle() {
            this.toggleDetails = !this.toggleDetails;
            this.$nextTick(() => {
                const elements = this.$el.querySelectorAll('.product-price-details');
                MatchHeight.add(elements, 'pricedetails');
            })
        },
        updateSwiper() {
            if (this.swiperOptions.slidesPerView === 0) return;

            if (!this.swiper) {
                this.swiper = new Swiper(this.$refs.swiper, {
                    ...this.swiperOptions,
                    modules: [Pagination, Navigation],
                    grabCursor: true,
                    loop: false,
                    centerInsufficientSlides: true,
                    watchOverflow: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                });
                if(this.settings.debugmodus) console.debug('created swiper', this.swiperOptions, this.swiper);
            } else {
                this.swiper.update();
                if(this.settings.debugmodus) console.debug('updated swiper', this.swiperOptions, this.swiper);
            }
        },
        onResize() {
            this.windowWidth = window.innerWidth;
            this.$nextTick(() => {
                this.updateSwiper();
            });
        },
        handleMatchHeightForTariffItems() {
            this.$nextTick(() => {
                const swiperElements = this.$el.querySelectorAll('.txt-03 .details');
                MatchHeight.add(swiperElements, 'txt-03');
            });
        },
    },
    watch: {
        visibleTarife() {
            this.$nextTick(() => {
                this.updateSwiper();

                if(this.settings.ergebnisunterrechner == '1') {
                    let scrollPos = $('.section-tariffswiper').offset().top - $('header').height();
                    if(this.visibleTarife.length > 0) $('html, body').animate({scrollTop: scrollPos}, '500');
                }
            });
        }
    }
}
</script>
